// constants for the different subscribable types
export const EXAM = 'exam'
export const GROUP = 'group'
export const SINGLE = 'single'
export const APPOINTMENT = 'appointment'
export const COURSE = 'course'

// SubscribableGrouping categories
export const RUBRIC = 'rubric'
export const STONE_TWO = 'stone_two'
export const STONE_THREE = 'stone_three'

export const SUBSCRIBED = 'subscribed'
export const CAN_SUBSCRIBE = 'can_subscribe'

// Grouping Categories
export const CATEGORY_RUBRIC = 'rubric'
export const CATEGORY_STUDY_PLAN = 'study_plan'
export const CATEGORY_ADVANCED_RULES = 'advanced_rules'

// Question types
export const TYPE_OPEN = 'open'
export const TYPE_BOOLEAN = 'boolean'
export const TYPE_MULTIPLE_CHOICE_SINGLE = 'multiple_choice_single'
export const TYPE_MULTIPLE_CHOICE_MULTIPLE = 'multiple_choice_multiple'
export const TYPE_EXAM_CHARACTERISTICS = 'exam_characteristics'
export const QUESTION_ANSWER_TYPES = [TYPE_MULTIPLE_CHOICE_SINGLE, TYPE_MULTIPLE_CHOICE_MULTIPLE, TYPE_EXAM_CHARACTERISTICS]

// Subscribable Queue actions
export const ACTION_SUBSCRIBE = 'subscribe'
export const ACTION_SEND_NOTIFICATION = 'send_notification'
export const ACTION_UNSUBSCRIBE_OTHER = 'unsubscribe_other'

// Assessment config types
export const ASSESSMENT_CONFIG_TYPES = {
  single_student: 'single_student',
}

export const PERMITTED_ABSENT = 'permitted_absent'

export const COURSE_CONTEXT_EXEMPTION = 'exemption'

export const MATRIX_SUBSCRIBABLES_CHUNK_SIZE = 10
export const MATRIX_STUDENTS_CHUNK_SIZE = 250
export const MATRIX_ATTENDANCE_GOALS_CHUNK_SIZE = 10

// colors also defined in colors.php
export const COLORS = {
  attended: '#117733', // Bright green

  // Color group: other classes // YellowGreen
  otherClass: '#44AA99',
  attended_not_schedule: '#44AA99',

  // Color group: absent // Red
  absent: '#882255',
  notAttended: '#882255',

  // Color group: not registered
  absent_not_registered: '#CC6677',
  notRegistered: '#CC6677',

  excused: '#808080',
  upcoming: '#88CCEE',
  defaultGrey: '#808080',

  // Live schedule colors
  live_schedule_attended: '#117733',
  live_schedule_absent: '#882255',
  live_schedule_future: '#88CCEE',
  live_schedule_not_same: '#DDCC77',
  subscribable: '#332288',

  // Exam
  exam: '#6a0dad',
}

export const STUDENT_SERIE_STATUS = {
  finished: 'finished',
  pending: 'pending',
  failed: 'failed',
  not_relevant: 'not_relevant',
}

export const ATTENDED = 'attended'
export const ABSENT = 'absent'
export const NOTICED_ABSENT = 'noticed_absent'
export const EXCUSED = 'excused'
export const ATTENDED_NOT_SCHEDULE = 'attended_not_schedule'
export const FUTURE = 'future'
export const ABSENT_NOT_REGISTERED = 'absent_not_registered'
export const CLASSIFICATION_CONFIG_GROUP = 'group'
export const CLASSIFICATION_CONFIG_SUBSCRIBABLE_GROUPING = 'subscribable_grouping'
export const NOT_REGISTERED = 'not_registered'

export const RULE_TYPE = {
  composite: 'composite',
  subscriptions_count: 'subscriptions_count',
  if: 'if',
  specific_subscription: 'specific_subscription',
  ects_count: 'ects_count',
  not: 'not',
  filter: 'filter',
  description: 'description',
  overlap: 'overlap',
  aggregate: 'aggregate',
  student_characteristic: 'student_characteristic',
}

export const OPERATOR_TYPE = {
  and: 'and',
  or: 'or',
}

export const FILTER_OPERATOR_TYPE = {
  and: 'and',
  or: 'or',
  eq: 'eq',
  gt: 'gt',
  lt: 'lt',
}

export const STATE_OPERATOR_TYPE = {
  subscribed: 'subscribed',
  unsubscribed: 'unsubscribed',
}

export const GROUP_CATEGORY = {
  config: 'config',
  database: 'database',
}

export const RULE_PROPERTY = {
  min: 'min',
  max: 'max',
  if: 'if',
  else: 'else',
  then: 'then',
  subscribable: 'subscribable',
  student_characteristic: 'student_characteristic',
  rule: 'rule',
  filter: 'filter',
  questions: 'questions',
  answers: 'answers',
  value: 'value',
  values: 'values',
  operator: 'operator',
  count: 'count',
  description: 'description',
  nl: 'nl',
  en: 'en',
}

export const SELECTOR_TYPE = {
  composite: 'composite',
  not: 'not',
  subscribable: 'subscribable',
  subscribable_grouping: 'subscribable_grouping',
  group: 'group',
  mentor: 'mentor',
  student_characteristic: 'student_characteristic',
}

export const SELECTOR_PROPERTY = {
  subscribable: 'subscribable',
  selector: 'selector',
  selectors: 'selectors',
  complied: 'complied',
  group: 'group',
  mentor: 'mentor',
  date: 'date',
  student_characteristic: 'student_characteristic',
  values: 'values',
  state: 'state',
  answers: 'answers',
  answer_operator: 'answer_operator',
}
